import {
  SENDGRID_REPORT_ENTRIES_CREATE,
  SENDGRID_REPORT_ENTRIES_SUCCESS,
  SENDGRID_REPORT_UPDATE_REQUEST,
  SENDGRID_REPORT_UPDATE_SUCCESS,
  SENDGRID_REPORT_DELETE_REQUEST,
  SENDGRID_REPORT_DELETE_SUCCESS,
  SENDGRID_REPORT_FETCH_SUCCESS,
  SENDGRID_REPORT_PREFERENCES_FETCH,
  SENDGRID_REPORT_RUNNOW_SUCCESS,
  SENDGRID_REPORT_RUNNOW_CREATE
} from './sendgrid-reports.type'

import ApiRest from '@/api/api-rest'

const state = {
  // sendgridReportEntries: {},
  sendgridReportReqStatus: '',
  userReportPreferences: null
}

const getters = {
  // sendgridReportEntries: state => state.sendgridReportEntries,
  userReportPreferences: state => state.userReportPreferences
}

const mutations = {
  [SENDGRID_REPORT_ENTRIES_SUCCESS]: state => (state.sendgridReportReqStatus = 'success'),
  [SENDGRID_REPORT_UPDATE_SUCCESS]: state => (state.sendgridReportReqStatus = 'success'),
  [SENDGRID_REPORT_DELETE_SUCCESS]: state => (state.sendgridReportReqStatus = 'success'),
  [SENDGRID_REPORT_FETCH_SUCCESS]: state => (state.sendgridReportReqStatus = 'success'),
  [SENDGRID_REPORT_RUNNOW_SUCCESS]: state => (state.sendgridReportReqStatus = 'success'),
  [SENDGRID_REPORT_PREFERENCES_FETCH]: (state, data) => {
    state.userReportPreferences = data
  }
}

const actions = {
  [SENDGRID_REPORT_ENTRIES_CREATE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('sendgrid-reports', payload)
        .then(({ data }) => {
          context.commit(SENDGRID_REPORT_ENTRIES_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          console.log(errMsg)
          reject(errMsg)
        })
    })
  },
  [SENDGRID_REPORT_UPDATE_REQUEST](context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .put(`sendgrid-reports/${payload.useremail}`, payload)
        .then(({ data }) => {
          context.commit(SENDGRID_REPORT_UPDATE_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          console.log(errMsg)
          reject(errMsg)
        })
    })
  },
  [SENDGRID_REPORT_DELETE_REQUEST](context, { userEmail, dateSelection } = ' ') {
    return new Promise((resolve, reject) => {
      ApiRest()
        .delete(`sendgrid-reports/${userEmail}/${dateSelection}`, {
          user_email: userEmail,
          date_selection: dateSelection
        })
        .then(resp => {
          context.commit(SENDGRID_REPORT_DELETE_SUCCESS)
          resolve(resp)
        })
        .catch(errMsg => {
          console.log(errMsg)
          reject(errMsg)
        })
    })
  },

  // Fetching user preference as per user_email
  [SENDGRID_REPORT_PREFERENCES_FETCH](context, { userEmail, dateSelection } = ' ') {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get(`fetch_sendgrid-report_preference/${userEmail}/${dateSelection}`, {
          user_email: userEmail,
          date_selection: dateSelection
        })
        .then(data => {
          context.commit(SENDGRID_REPORT_FETCH_SUCCESS)
          context.commit(SENDGRID_REPORT_PREFERENCES_FETCH, data)
          resolve(data)
        })
        .catch(errMsg => {
          console.log(errMsg)
          reject(errMsg)
        })
    })
  },
  
  // Saving RUN-NOW Preferences
  [SENDGRID_REPORT_RUNNOW_CREATE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('sendgrid-reports-runnow', payload)
        .then(({ data }) => {
          context.commit(SENDGRID_REPORT_RUNNOW_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          console.log(errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/reports/sendgrid-reports.module.js